import { getkwargs } from "../../utilities/functions";
import { onChange } from "../onchange";

export const onChangeUser = ({
  context,
  company_id,
  model = "res.users",
}) => {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        [],
        {},
        [],
        {
          state: "",
          signup_url: "1",
          signup_valid: "1",
          id: "",
          groups_count: "",
          accesses_count: "",
          rules_count: "",
          active_partner: "",
          partner_id: "1",
          image_1920: "1",
          __last_update: "",
          name: "1",
          email: "1",
          login: "1",
          company_ids: "",
          company_id: "",
          companies_count: "",
          sel_groups_1_9_10: "",
          sel_groups_20_21_22_56: "",
          sel_groups_26_27_28_57: "",
          sel_groups_37_38_58: "",
          sel_groups_47_48: "",
          sel_groups_2_3: "",
          in_group_60: "",
          in_group_59: "",
          in_group_29: "",
          in_group_44: "",
          in_group_51: "",
          in_group_11: "",
          in_group_7: "",
          in_group_50: "",
          in_group_16: "",
          in_group_30: "",
          in_group_13: "",
          in_group_14: "",
          in_group_15: "",
          in_group_19: "",
          in_group_40: "",
          in_group_55: "",
          in_group_54: "",
          in_group_49: "",
          in_group_43: "",
          in_group_39: "",
          in_group_35: "",
          in_group_12: "",
          in_group_36: "",
          in_group_41: "",
          in_group_17: "",
          in_group_18: "",
          in_group_42: "",
          in_group_46: "",
          in_group_52: "",
          in_group_32: "",
          in_group_53: "",
          in_group_45: "",
          in_group_31: "",
          in_group_25: "",
          in_group_33: "",
          in_group_34: "",
          in_group_23: "",
          in_group_24: "",
          in_group_8: "",
          in_group_4: "",
          in_group_5: "",
          in_group_6: "",
          totp_enabled: "",
          active: "",
          lang: "1",
          tz: "1",
          tz_offset: "",
          action_id: "",
          notification_type: "",
          odoobot_state: "",
          signature: "",
          property_warehouse_id: "",
        },
      ],
      model,
      method: "onchange",
      ...getkwargs({ company_id, context, model, view_type: "form" }),
    },
  });

  return onChange(raw, model);
};
